module.exports = __webpack_public_path__ + "media/images/icons/icons_small/30_earings-a67c81eed4e06a065712a1fa287a1cc1.png";